import React, { useEffect, useState } from 'react'
import SubmissionReviewsList from './SubmissionReviewsList'
import ReviewSubmissionForm from './ReviewSubmissionForm'
import { useParams } from 'react-router'
import { useFetchSubmissionReviewsQuery } from '../../../../store/apis/submission.api'
import { fetchSubmissionReviewsSelectors } from '../../../../store/apis/utils/selectors/submission.api.selectors'
import { useSelector } from 'react-redux'
import submissionSelectors from '../../../../store/selectors/submission.selectors'

const ReviewSubmission = () => {
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)

    const { token, layerId } = useParams()
    const { data: isReviewed } = useFetchSubmissionReviewsQuery(
        { token, layerId },
        {
            selectFromResult: result =>
                fetchSubmissionReviewsSelectors.isReviewedById({ id: openedSubmissionId }, result),
        },
    )
    const [rereviewMode, setRereviewMode] = useState(false)

    useEffect(() => setRereviewMode(false), [openedSubmissionId])

    const onSuccess = () => {
        setRereviewMode(false)
    }

    return rereviewMode || !isReviewed ? (
        <ReviewSubmissionForm onSuccess={onSuccess} onCancel={isReviewed ? () => setRereviewMode(false) : null} />
    ) : (
        <SubmissionReviewsList setRereviewMode={setRereviewMode} />
    )
}

export default ReviewSubmission
